import { Customer } from '../../../common/graphql/fragments/gql/Customer';
import { useAccount } from '../../settings/hooks/useAccount';

export const useAllIntermodalCustomers = (): Customer[] => {
  const settings = useAccount();

  return settings.customers.filter(cust => cust.isIntermodal);
};
